var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseReturnCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66669 47.6667V39C8.66669 23.8333 17.3334 17.3333 30.3334 17.3333H73.6667C86.6667 17.3333 95.3334 23.8333 95.3334 39V65C95.3334 80.1667 86.6667 86.6667 73.6667 86.6667H52",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 62.8333C57.9831 62.8333 62.8334 57.9831 62.8334 52C62.8334 46.0169 57.9831 41.1667 52 41.1667C46.0169 41.1667 41.1667 46.0169 41.1667 52C41.1667 57.9831 46.0169 62.8333 52 62.8333Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1667 41.1667V62.8333",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66669 67.1667H31.8068C34.5801 67.1667 36.8334 69.4199 36.8334 72.1932V77.74",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9532 61.8801L8.66669 67.1667L13.9532 72.4532",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8334 90.0468H13.6932C10.9199 90.0468 8.66669 87.7933 8.66669 85.02V79.4734",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5521 95.3347L36.8387 90.0481L31.5521 84.7613",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseReturnCard);
export default __webpack_public_path__ + "static/media/purchase-return-card.db619f062102ce102451d007aa464ae8.svg";
export { ForwardRef as ReactComponent };